import { ApolloQueryResult } from '@apollo/client';
import { createContext } from 'react';

export const OpenedConversationsContext = createContext<number>(0);
export const RefreshOpenedConversationsContext = createContext<null | (() => any)>(null);
